import { combineReducers } from 'redux';
import { FilterReducer } from 'Redux/reducers/FilterReducer';

export default combineReducers({ FilterReducer });
